import { makeRequest } from 'utils/requestLogger';

export default (rtID) =>
  makeRequest('get', `/api/roundtables/${rtID}/me`).then((res) => res.data);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/myRoundtableIdentity.js